module.exports = __webpack_public_path__ + "img/1.54f63ce.png";